// extracted by mini-css-extract-plugin
module.exports = {"loader":"generatePasses_loader__233vy","spin":"generatePasses_spin__1PIVa","container":"generatePasses_container__3e8Ke","box":"generatePasses_box__2zRWR"};